import { EquipmentDocument } from '../Equipment/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import {
  TargetBorerRunningTimeDocument,
  targetBorerRunningTimesPullQueryBuilder,
} from './queryBuilder';

export function targetBorerRunningTimesFamilyMember(
  configBuilder: ConfigBuilder,
  equipment: FamilyMember<EquipmentDocument>,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<TargetBorerRunningTimeDocument> {
  const syncConfig = configBuilder<TargetBorerRunningTimeDocument>(
    RxdbCollectionNameV2.TARGET_BORER_RUNNING_TIMES,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, targetBorerRunningTimesPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.TARGET_BORER_RUNNING_TIMES, replicationState, [
    equipment,
    sites,
  ]);
}
